export class PasswordCheckRequestFailed extends Error {
  constructor() {
    super('PasswordCheckRequestFailed');
  }

}